import React, { useEffect, useState, useContext } from "react";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  Button,
  InputAdornment,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ProgressContext } from "../ContextAPI";
import { api, get, post, put } from "../../../utils/api";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import {
  textError,
  percentageError,
  numberError,
} from "../../../utils/validationMessage";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const BoardComposition = () => {
  const companyDetails = getQuestionareSubmitted();

  const navigate = useNavigate();
  const { setUpdate } = useContext(ProgressContext);
  const [isExist, setIsExist] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [DeleteIndex, setIndexDelete] = useState(0);
  const [form, setFrom] = useState({
    boardIndependance: 0,
    boardDiversity: {
      Male: 0,
      Female: 0,
      MinAge: 0,
      MaxAge: 0,
      MinYears: 0,
      MaxYears: 0,
    },
    boardMeetingAttendance: 0,
    boardCommittees: {
      Total: 0,
      Type: [""],
      Range: [0],
    },
  });
  const [fieldToRemove, setFieldToRemove] = React.useState({
    fieldName: "",
    index: null,
  });
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFrom({
      ...form,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const handleChangeCommitteesTotal = (e) => {
    const { name, value } = e.target;
    console.log(value, "valuefor commit");
    // setFrom({
    //   ...form,
    //   boardCommittees: {
    //     ...form.boardCommittees,
    //     [name]: value,
    //   },
    // });
    setFrom((prevForm) => {
      const total = parseInt(value) || 1; // Ensure valid number, default to 1 if empty
      console.log(total, "total for boardCommittees");

      const updatedCommittees = {
        ...prevForm.boardCommittees,
        [name]: value,
      };

      // Preserve existing values and ensure the arrays match the new total length
      updatedCommittees.Type = [
        ...prevForm.boardCommittees.Type.slice(0, total), // Keep existing values
        ...new Array(
          Math.max(0, total - prevForm.boardCommittees.Type.length)
        ).fill(""),
      ];

      updatedCommittees.Range = [
        ...prevForm.boardCommittees.Range.slice(0, total), // Keep existing values
        ...new Array(
          Math.max(0, total - prevForm.boardCommittees.Range.length)
        ).fill(""),
      ];

      return {
        ...prevForm,
        boardCommittees: updatedCommittees,
      };
    });
    //   errors.boardCommittees?.map((_, i) => {
    //   setErrors({
    //     ...errors,
    //     boardCommittees: {
    //       ...errors.boardCommittees,
    //       [name]: "",
    //     [`boardCommitteesRange${i}`]: "",
    // [`boardCommitteesType${i}`]: "",
    //     },

    //   });})
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors, [name]: "" };
      Array.from({ length: value === (0 || " ") ? 1 : value }).forEach(
        (_, i) => {
          console.log(i, "indexchecking");
          updatedErrors[`boardCommitteesRange${i}`] = "";
          updatedErrors[`boardCommitteesType${i}`] = "";
        }
      );

      return updatedErrors;
    });
  };

  const handleChangeCommittees = (e, index, fieldType) => {
    const { name, value } = e.target;
    //   setFrom({
    //     ...form,
    //     boardCommittees:{
    //       ...form.boardCommittees,
    //       [name]: value}
    // })
    const updatedCommittees = { ...form.boardCommittees };
    updatedCommittees[fieldType][index] = value;
    setFrom({
      ...form,
      boardCommittees: updatedCommittees,
    });
  };
  const handleRemoveField = (fieldName, index) => {
    setOpenDialog(true);
    // setFieldToRemove({ fieldName, index });
    setIndexDelete(index);
  };
  const validateForm = () => {
    const newErrors = {};

    const {
      boardIndependance,
      boardDiversity,
      boardMeetingAttendance,
      boardCommittees,
    } = form;

    // Validate `boardIndependance`
    if (
      // !boardIndependance ||
      boardIndependance < 0 ||
      boardIndependance > 100 ||
      // ||typeof (boardIndependance) !== 'string'

      !/^\d*\.?\d*$/.test(boardIndependance)
    ) {
      newErrors.boardIndependance = percentageError;
    }

    // Validate `boardDiversity`
    if (
      boardDiversity.Male &&
      (isNaN(boardDiversity.Male) ||
        boardDiversity.Male <= 0 ||
        !/^\d*\.?\d*$/.test(boardDiversity.Male))
    ) {
      newErrors.boardDiversityMale = numberError;
    }

    if (
      boardDiversity.Female &&
      (isNaN(boardDiversity.Female) ||
        boardDiversity.Female <= 0 ||
        !/^\d*\.?\d*$/.test(boardDiversity.Female))
    ) {
      newErrors.boardDiversityFemale = numberError;
    }

    if (
      boardDiversity.MinAge &&
      (boardDiversity.MinAge <= 0 || !/^\d*\.?\d*$/.test(boardDiversity.MinAge))
    ) {
      newErrors.boardDiversityMinAge = numberError;
    }

    if (
      boardDiversity.MaxAge &&
      (boardDiversity.MaxAge <= 0 || !/^\d*\.?\d*$/.test(boardDiversity.MaxAge))
    ) {
      newErrors.boardDiversityMaxAge = numberError;
    }

    if (
      boardDiversity.MinYears &&
      (boardDiversity.MinYears <= 0 ||
        !/^\d*\.?\d*$/.test(boardDiversity.MinYears))
    ) {
      newErrors.boardDiversityMinYears = numberError;
    }

    if (
      boardDiversity.MaxYears &&
      (boardDiversity.MaxYears <= 0 ||
        !/^\d*\.?\d*$/.test(boardDiversity.MaxYears) ||
        (boardDiversity.MinYears &&
          Number(boardDiversity.MaxYears) < Number(boardDiversity.MinYears)))
    ) {
      newErrors.boardDiversityMaxYears = numberError;
    }
    // Validate `boardMeetingAttendance`
    if (
      boardMeetingAttendance !== "" &&
      boardMeetingAttendance !== undefined &&
      (!/^\d*\.?\d*$/.test(boardMeetingAttendance) ||
        boardMeetingAttendance < 0 ||
        boardMeetingAttendance > 100)
    ) {
      newErrors.boardMeetingAttendance = percentageError;
    }
    // Validate `boardCommittees`
    if (
      boardCommittees.Total && // only validate if a value is entered
      (!/^\d*\.?\d+$/.test(boardCommittees.Total) ||
        Number(boardCommittees.Total) <= 0)
    ) {
      newErrors.boardCommitteesTotal = numberError;
    }

    boardCommittees.Type.forEach((type, index) => {
      if (!type || type.trim() === "") {
        newErrors[`boardCommitteesType${index}`] = textError; // Index-specific error for Type
      }
    });

    if (boardCommittees.Total)
      // Validate boardCommittees.Range array index-wise
      boardCommittees.Range.forEach((value, index) => {
        if (
          isNaN(value) ||
          //  || typeof (value) !== 'string'
          !/^\d*\.?\d*$/.test(value) ||
          value <= 0 ||
          value > 100
        ) {
          newErrors[`boardCommitteesRange${index}`] = percentageError; // Index-specific error for Range
        }
        console.log(boardCommittees.Type.length, "boardCommittees.Type.length");
      });

    console.log(newErrors, boardDiversity, "newErrors");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChangeDiversity = (e) => {
    const { name, value } = e.target;
    setFrom({
      ...form,
      boardDiversity: {
        ...form.boardDiversity,
        [name]: value,
      },
    });
    setErrors({
      ...errors,
      boardDiversity: {
        ...errors.boardDiversity,
        [name]: "",
      },
    });
  };
  // console.log(form)
  useEffect(() => {
    setUpdate("GOVERNANCE");
    const fetchData = async () => {
      try {
        const response = await get(`${api}/governance/Board-composition`);
        setFrom({
          boardIndependance: response.data.boardIndependance,
          boardDiversity: {
            Male: response.data.boardDiversity.Male,
            Female: response.data.boardDiversity.Female,
            MinAge: response.data.boardDiversity.MinAge,
            MaxAge: response.data.boardDiversity.MaxAge,
            MinYears: response.data.boardDiversity.MinYears,
            MaxYears: response.data.boardDiversity.MaxYears,
          },
          boardMeetingAttendance: response.data.boardMeetingAttendance,
          boardCommittees: {
            Total: response.data.boardCommittees.Total,
            Type: response.data.boardCommittees.Type,
            Range: response.data.boardCommittees.Range,
          },
        });
        //  console.log("dataforthedata",response.data.boardCommittees,response.data.boardCommittees.Range,response.data.boardCommittees.Type)
        setIsExist(true);
      } catch (err) {
        console.error("Error:", err);
        // alert(err);
      }
    };
    fetchData();
  }, []);

  const AddTextField = () => {
    const updatedCommittees = { ...form.boardCommittees };
    updatedCommittees.Type.push("");
    updatedCommittees.Range.push("");
    setFrom({
      ...form,
      boardCommittees: updatedCommittees,
    });
    setErrors((prev) => ({
      ...prev,
      boardCommitteesTotal: "",
    }));
  };

  const confirmRemoveField = () => {
    const updatedCommittees = { ...form.boardCommittees };

    // Remove the element at the specific index from both Type and Range arrays
    updatedCommittees.Type.splice(DeleteIndex, 1);
    updatedCommittees.Range.splice(DeleteIndex, 1);

    setFrom({
      ...form,
      boardCommittees: updatedCommittees,
    });
    setOpenDialog(false);
  };
  const cancelRemoveField = () => {
    setOpenDialog(false);
  };
  const Save = async () => {
    // if (!validateForm()) {
    //   return;
    // }
    const hasValidValue = (val) =>
      val !== undefined &&
      val !== null &&
      val.toString().trim() !== "" &&
      val !== "NaN";

    const diversity = form.boardDiversity || {};
    const committees = form.boardCommittees || {};

    const boardComposition =
      hasValidValue(form.boardIndependance) &&
      hasValidValue(form.boardMeetingAttendance) &&
      hasValidValue(diversity.Female) &&
      hasValidValue(diversity.Male) &&
      hasValidValue(diversity.MinAge) &&
      hasValidValue(diversity.MaxAge) &&
      hasValidValue(diversity.MinYears) &&
      hasValidValue(diversity.MaxYears) &&
      Array.isArray(committees.Type) &&
      committees.Type.length > 0 &&
      Array.isArray(committees.Range) &&
      committees.Range.length > 0 &&
      hasValidValue(committees.Total);

    const payload = {
      ...form,
      board_composition: boardComposition,
    };
    let method = isExist ? put : post;
    let url = `/governance/Board-composition`;
    await method(url, payload)
      .then((response) => {
        navigate(
          companyDetails?.questionareSubmitted
            ? "/preview"
            : "/governance/executive-compensation"
        );
      })
      .catch((err) => {
        console.log(err, err.data);
        alert(err.message);
      });
  };

  const Back = () => {
    navigate("/social/supply-chain");
    setUpdate("SOCIAL");
  };

  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        height: "100vh",
        backgroundColor: "#EDEDED",
      }}
    >
      <Dialog open={openDialog} onClose={cancelRemoveField}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this field?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelRemoveField} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmRemoveField} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        sx={{
          p: 2,
          mt: 3,
          width: "75vw",
          height: "100vh", // Full viewport height
          overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to start at the top of the box
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              width: "60%",
              fontWeight: "bold",
              zIndex: 1,
              padding: "10px 0px",
              borderRadius: "4px",
              alignSelf: "flex-start",
            }}
          >
            GOVERNANCE: BOARD COMPOSITION & EFFECTIVENESS
          </Typography>
          <SkipQuestionare />
        </div>

        <Box sx={{ width: "80%" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
          >
            Board Independence
          </Typography>
          <TextField
            variant="outlined"
            placeholder="% of independent directors"
            // type='number'
            name="boardIndependance"
            // inputMode="numeric"
            value={form.boardIndependance === 0 ? "" : form.boardIndependance}
            // InputProps={{
            //   endAdornment: <InputAdornment position="end">%</InputAdornment>,
            // }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        height: "30px",
                        width: "1px",
                        bgcolor: "#6b6c6d",
                        marginRight: "8px",
                      }}
                    />
                    %
                  </Box>
                </InputAdornment>
              ),
              style: {
                borderColor: errors.boardIndependance ? "#D34040" : undefined,
              },
            }}
            sx={{
              // '& input[type=number]': {
              //   MozAppearance: 'textfield',
              //   WebkitAppearance: 'none',
              // },
              // mb: 2,
              width: "100%",
            }}
            onChange={(e) => {
              const value = e.target.value;
              if (
                /^\d*\.?\d*$/.test(value) &&
                (value === "" || parseFloat(value) <= 100)
              ) {
                handleChange(e);
                setErrors({ ...errors, boardIndependance: "" });
              }
            }}
            error={!!errors.boardIndependance} // Show error styling if there's an error
            InputLabelProps={{
              style: {
                color: errors.boardIndependance ? "#D34040" : undefined,
              },
            }}
          />
          {errors.boardIndependance && (
            <Typography variant="body2" color="#D34040">
              {errors.boardIndependance}
            </Typography>
          )}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
          >
            Board Diversity
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mb: 2, width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                name="Male"
                type="text"
                placeholder="Male"
                value={
                  form.boardDiversity.Male === 0 ? "" : form.boardDiversity.Male
                }
                fullWidth
                onChange={(e) => {
                  handleChangeDiversity(e);
                  setErrors({ ...errors, boardDiversityMale: "" });
                }}
                error={!!errors.boardDiversityMale} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityMale
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityMale ? "#D34040" : undefined,
                  },
                }}
              />
              {errors.boardDiversityMale && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityMale}
                </Typography>
              )}
            </Box>
            :
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                name="Female"
                placeholder="Female"
                value={
                  form.boardDiversity.Female === 0
                    ? ""
                    : form.boardDiversity.Female
                }
                fullWidth
                onChange={(e) => {
                  handleChangeDiversity(e);
                  setErrors({ ...errors, boardDiversityFemale: "" });
                }}
                error={!!errors.boardDiversityFemale} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityFemale
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityFemale ? "#D34040" : undefined,
                  },
                }}
              />
              {errors.boardDiversityFemale && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityFemale}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 1, mb: 2, width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Minimum Age"
                name="MinAge"
                value={
                  form.boardDiversity.MinAge === 0
                    ? ""
                    : form.boardDiversity.MinAge
                }
                fullWidth
                onChange={(e) => {
                  handleChangeDiversity(e);
                  setErrors({ ...errors, boardDiversityMinAge: "" });
                }}
                error={!!errors.boardDiversityMinAge} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityMinAge
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityMinAge ? "#D34040" : undefined,
                  },
                }}
              />
              {errors.boardDiversityMinAge && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityMinAge}
                </Typography>
              )}
            </Box>
            _
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Maximum Age"
                name="MaxAge"
                value={
                  form.boardDiversity.MaxAge === 0
                    ? ""
                    : form.boardDiversity.MaxAge
                }
                fullWidth
                onChange={(e) => {
                  handleChangeDiversity(e);
                  setErrors({ ...errors, boardDiversityMaxAge: "" });
                }}
                error={!!errors.boardDiversityMaxAge} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityMaxAge
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityMaxAge ? "#D34040" : undefined,
                  },
                }}
              />
              {errors.boardDiversityMaxAge && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityMaxAge}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: "flex", width: "100%", gap: 1, mb: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Min. years of experience"
                fullWidth
                name="MinYears"
                value={
                  form.boardDiversity.MinYears === 0
                    ? ""
                    : form.boardDiversity.MinYears
                }
                onChange={handleChangeDiversity}
                error={!!errors.boardDiversityMinYears} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityMinYears
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityMinYears
                      ? "#D34040"
                      : undefined,
                  },
                }}
              />
              {errors.boardDiversityMinYears && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityMinYears}
                </Typography>
              )}
            </Box>
            _
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Max. years of experience"
                fullWidth
                name="MaxYears"
                value={
                  form.boardDiversity.MaxYears === 0
                    ? ""
                    : form.boardDiversity.MaxYears
                }
                onChange={(e) => {
                  handleChangeDiversity(e);
                  setErrors({ ...errors, boardDiversityMaxYears: "" });
                }}
                error={!!errors.boardDiversityMaxYears} // Show error styling if there's an error
                InputProps={{
                  style: {
                    borderColor: errors.boardDiversityMaxYears
                      ? "#D34040"
                      : undefined,
                  },
                }}
                InputLabelProps={{
                  style: {
                    color: errors.boardDiversityMaxYears
                      ? "#D34040"
                      : undefined,
                  },
                }}
              />
              {errors.boardDiversityMaxYears && (
                <Typography variant="body2" color="#D34040">
                  {errors.boardDiversityMaxYears}
                </Typography>
              )}
            </Box>
          </Box>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Board Meeting Attendance
          </Typography>
          <TextField
            variant="outlined"
            placeholder="80"
            name="boardMeetingAttendance"
            value={
              form.boardMeetingAttendance === 0
                ? ""
                : form.boardMeetingAttendance
            }
            // InputProps={{
            //   endAdornment: <InputAdornment position="end">%</InputAdornment>,
            // }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        height: "30px",
                        width: "1px",
                        bgcolor: "#6b6c6d",
                        marginRight: "8px",
                      }}
                    />
                    %
                  </Box>
                </InputAdornment>
              ),
              style: {
                borderColor: errors.boardMeetingAttendance
                  ? "#D34040"
                  : undefined,
              },
            }}
            sx={{ mb: 0, width: "100%" }}
            error={!!errors.boardMeetingAttendance} // Show error styling if there's an error
            InputLabelProps={{
              style: {
                color: errors.boardMeetingAttendance ? "#D34040" : undefined,
              },
            }}
            onChange={(e) => {
              const value = e.target.value;
              if (
                /^\d*\.?\d*$/.test(value) &&
                (value === "" || Number(value) <= 100)
              ) {
                handleChange(e);
                setErrors({ ...errors, boardMeetingAttendance: "" });
              }
            }}
          />
          {errors.boardMeetingAttendance && (
            <Typography variant="body2" color="#D34040">
              {errors.boardMeetingAttendance}
            </Typography>
          )}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
          >
            Board Committees
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Total number of committees"
            sx={{ mb: errors.boardCommitteesTotal ? 0 : 2, width: "100%" }}
            name="Total"
            value={
              form.boardCommittees.Total === 0 ? "" : form.boardCommittees.Total
            }
            onChange={(e) => {
              handleChangeCommitteesTotal(e);
              setErrors({ ...errors, boardCommitteesTotal: "" });
            }}
            error={!!errors.boardCommitteesTotal} // Show error styling if there's an error
            InputProps={{
              style: {
                borderColor: errors.boardCommitteesTotal
                  ? "#D34040"
                  : undefined,
              },
            }}
            InputLabelProps={{
              style: {
                color: errors.boardCommitteesTotal ? "#D34040" : undefined,
              },
            }}
          />
          {errors.boardCommitteesTotal && (
            <Typography sx={{ mb: 1 }} variant="body2" color="#D34040">
              {errors.boardCommitteesTotal}
            </Typography>
          )}
          {/* <Box width="91%"> */}
          {/* {form.boardCommittees.Type.map((item, i) => { */}
          {/* return ( */}
          {console.log(form.boardCommittees.Total, "valuefor commit")}
          {Array.from({
            length:
              form.boardCommittees.Total === (0 || " ")
                ? 1
                : form.boardCommittees.Total,
          }).map((_, i) => (
            <Box key={i} sx={{ width: "110%", display: "flex" }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  mb: 2,

                  width: "100%",
                  // border: "1px solid red",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <TextField
                    variant="outlined"
                    placeholder="Type of committees"
                    fullWidth
                    name="Type"
                    // value={item}
                    value={
                      form.boardCommittees.Type[i] === 0
                        ? ""
                        : form.boardCommittees.Type[i]
                    }
                    onChange={(e) => {
                      handleChangeCommittees(e, i, "Type");
                      setErrors({
                        ...errors,
                        [`boardCommitteesType${i}`]: "",
                      });
                    }}
                    error={!!errors[`boardCommitteesType${i}`]} // Show error styling if there's an error
                    InputProps={{
                      style: {
                        borderColor: errors[`boardCommitteesType${i}`]
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                    InputLabelProps={{
                      style: {
                        color: errors[`boardCommitteesType${i}`]
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  />
                  {errors[`boardCommitteesType${i}`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`boardCommitteesType${i}`]}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Box display="flex" sx={{ width: "100%", gap: "10px" }}>
                    <TextField
                      variant="outlined"
                      placeholder="Attendance Rate"
                      fullWidth
                      // InputProps={{
                      //   endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      // }}

                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Box
                                sx={{
                                  height: "30px",
                                  width: "1px",
                                  bgcolor: "#6b6c6d",
                                  marginRight: "8px",
                                }}
                              />
                              %
                            </Box>
                          </InputAdornment>
                        ),
                        style: {
                          borderColor: errors[`boardCommitteesRange${i}`]
                            ? "#D34040"
                            : undefined,
                        },
                      }}
                      error={!!errors[`boardCommitteesRange${i}`]} // Show error styling if there's an error
                      InputLabelProps={{
                        style: {
                          color: errors[`boardCommitteesRange${i}`]
                            ? "#D34040"
                            : undefined,
                        },
                      }}
                      name="Range"
                      value={
                        form.boardCommittees.Range[i] === 0
                          ? ""
                          : form.boardCommittees.Range[i]
                      }
                      sx={{ mb: 0 }}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          /^\d*\.?\d*$/.test(value) &&
                          (value === "" || Number(value) <= 100)
                        ) {
                          handleChangeCommittees(e, i, "Range");
                          setErrors({
                            ...errors,
                            [`boardCommitteesRange${i}`]: "",
                          });
                        }
                      }}
                      // onChange={handleChangeCommittees}
                    />
                  </Box>
                  {errors[`boardCommitteesRange${i}`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`boardCommitteesRange${i}`]}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Box sx={{ width: "10%" }}>
                {/* {i > 0 && (
                  <IconButton>
                    <DeleteIcon onClick={() => handleRemoveField("", i)} />
                  </IconButton>
                )} */}
              </Box>
            </Box>
          ))}

          {/* </Box> */}

          {/* <Box
            sx={{
              mb: 3,
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              disabled={Number(form.boardCommittees.Total) === form.boardCommittees.Type.length?true:false}
              endIcon={<AddIcon />}
              sx={{
                boarderColor: "#0a3f73",
                color: "#0a3f73",
                textTransform: "none",
              }}
              onClick={AddTextField}
            >
              Add
            </Button>
          </Box> */}
          <ActionButtons
            Back={Back}
            Move={Save}
            disable={companyDetails?.questionareSubmitted}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BoardComposition;
